export const end = `
{{You Win![[x,x,x]]}}
{{Yeah, it was anticlimactic.[[x,x,x]]}}
{{But I did other shenanigans this Ludum Dare as well and ran out of time.[[x,x,x]]}}
`;
